import { connect } from 'react-redux';
import OrderSuccess from './OrderSuccess';
import { goToOrderPageAction } from '../../store/actions/order';

import { getIsPaylate } from '../../../../store/payment/selectors';

const mapStateToProps = (state) => ({
  isPaylate: getIsPaylate(state),
});

const mapDispatchToProps = {
  goToOrderPage: goToOrderPageAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderSuccess);
